<template>
<div>
    <img src="//cdn.edstatic.com/203012120000/f9f47a4439a33850fbd02a96c660a7b8/2022/12/7f39b2a2-dc50-4e2e-b432-ebb73b9338a3.jpg" :showIndex="false" @click="showBig=true">
    <h3>(长按识别二维码)</h3>
    <van-image-preview v-model="showBig" :images="['//cdn.edstatic.com/203012120000/f9f47a4439a33850fbd02a96c660a7b8/2022/12/7f39b2a2-dc50-4e2e-b432-ebb73b9338a3.jpg']" :showIndex="false" maxZoom="6">
    </van-image-preview>
</div>
</template>

<script>
import {ButtonDetail} from '../../config/interface.js'
export default {
    data(){
        return{
            showBig:false
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
    }
}
</script>

<style scoped>
h2{
    text-align: center;
    line-height: 30px;
    margin-top: 20px;
}
h3{
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;

}
img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/appDownload.vue